import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ColumnsType } from 'antd/es/table';
import { StatusImpactPill } from '~/app/components/dashboard/StatusImpactPill/StatusImpactPill';
import type { LocationRowViewModel } from '../ServiceQualityPage.types';

export function useLocationsColumns(): ColumnsType<LocationRowViewModel> {
  const { t } = useTranslation('dashboard');

  return useMemo(
    () => [
      {
        title: t('serviceQuality.locations.columns.location'),
        dataIndex: 'location',
        key: 'location',
      },
      {
        title: t('serviceQuality.locations.columns.region'),
        dataIndex: 'region',
        key: 'region',
      },
      {
        title: t('serviceQuality.locations.columns.sessionSuccess'),
        dataIndex: 'sessionSuccess',
        key: 'sessionSuccess',
      },
      {
        title: t('serviceQuality.locations.columns.avgRating'),
        dataIndex: 'avgRating',
        key: 'avgRating',
      },
      {
        title: t('serviceQuality.locations.columns.status'),
        dataIndex: 'statusLabel',
        key: 'status',
        render: (_value, row) => (
          <StatusImpactPill tone={row.statusTone} label={row.statusLabel} />
        ),
      },
    ],
    [t],
  );
}
